




















































import { Component, Mixins } from 'vue-property-decorator'
import TreeDiaryItem from '../mixins/TreeDiaryItem'

@Component({
  name: 'TreeDiaryLike',
})
export default class TreeDiaryLike extends Mixins(TreeDiaryItem) {
  // Computed
  get text(): string {
    return this.translate('pageTree.diary.love.text', {
      user: this.post.user.firstName,
      userSlug: this.post.user.slug,
      link: this.parseState(
        this.post.user.userType === 'Private' ? 'user' : 'organization',
        { slug: this.post.user.slug }
      ),
    })
  }
}
